import {useEffect, useState} from "react";
import moment from "moment-timezone";
import "moment-timezone";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

import SortByHeader from "components/ordering/SortByHeader";
import useCustomTranslation from "core/customTranslation";
import translations from "../translations";
import ColorLegend from "../../../components/legends/ColorLegend";

const ContainersListTable = ({itemsShown, dateHeaders, orderRef}) => {
    const {t: _TC} = useCustomTranslation(translations);
    const {t: _Tc} = useTranslation("choices");
    const [processedItems, setProcessedItems] = useState([]);

    // useEffect(() => {
    //
    // }, [filters, itemsShown, selectedDays]);

    // Efecto para procesar los items y asignarles un color de grupo
    useEffect(() => {
        if (!itemsShown || itemsShown.length === 0) {
            setProcessedItems([]);
            return;
        }

        const islandCounts = itemsShown.reduce((acc, item) => {
            acc[item.island_id] = (acc[item.island_id] || 0) + 1;
            return acc;
        }, {});

        const islandGroups = Object.keys(islandCounts).filter((id) => islandCounts[id] > 1);

        const pastelColors = [
            "rgba(210, 180, 222, 0.4)", // Lavanda
            "rgba(169, 204, 227, 0.4)", // Azul claro
            "rgba(249, 231, 159, 0.4)", // Amarillo pálido
            "rgba(245, 183, 177, 0.4)", // Rosa
            "rgba(163, 228, 215, 0.4)", // Menta
        ];

        const colorMap = islandGroups.reduce((map, islandId, index) => {
            map[islandId] = pastelColors[index % pastelColors.length];
            return map;
        }, {});

        const processed = itemsShown.map((item) => ({
            ...item,
            groupColor: colorMap[item.island_id],
        }));

        setProcessedItems(processed);
    }, [itemsShown]);

    const thStyleDates = {
        borderBottom: "1px solid #7e7e7e",
        borderRight: "1px solid #7e7e7e",
        verticalAlign: "middle",
        maxWidth: "54px",
        minWidth: "54px",
        width: "54px",
        fontSize: "11px",
        lineHeight: 0.5,
        padding: "0.6rem 0.1rem",
    };
    const tdStyleData = {
        maxWidth: "54px",
        minWidth: "54px",
        textAlign: "center",
        verticalAlign: "middle",
        width: "54px",
        lineHeight: "1",
        fontSize: "13px",
        padding: "0.4rem 0.2rem",
    };
    const tdStyleIsland = {
        maxWidth: "196px",
        minWidth: "90px",
        width: "90px",
        padding: "0.4rem 0.2rem",
        lineHeight: "1.5",
    };

    const renderValue = (val) => {
        if (val === null || val === undefined || val === "") return "-";
        if (typeof val === "number") {
            return val % 1 === 0 ? val : val.toFixed(2).replace(".", ",");
        }
        return val;
    };

    const getLevelColor = (value) => {
        if (value === null || value === undefined) return "transparent";
        if (value >= 75) return "rgb(255 117 0 / 0.83)";
        if (value >= 50) return "rgb(220 220 220)";
        if (value >= 30) return "rgba(33, 150, 243, 0.7)";
        return "rgb(255 224 93 / 0.58)";
    };

    return (
        <div className="col-12" style={{overflowX: "auto"}}>
            <hr className="mb-3" />
            {!processedItems || processedItems.length === 0 ? (
                <div className="alert alert-secondary text-center">{_TC("filters.noData")}</div>
            ) : (
                <table className="table" style={{fontSize: "0.85em"}}>
                    <thead>
                        {/* ... Tu thead se mantiene igual ... */}
                        <tr>
                            <th
                                colSpan="4"
                                className="text-center border-start"
                                style={{
                                    borderBottom: "1px solid #7e7e7e",
                                    borderRight: "1px solid #7e7e7e",
                                    verticalAlign: "middle",
                                }}></th>
                            <th
                                colSpan={dateHeaders.length}
                                className="text-center border-start"
                                style={{borderBottom: "1px solid #7e7e7e", verticalAlign: "middle"}}>
                                {_TC("tables.dailyLevels")}
                            </th>
                        </tr>
                        <tr>
                            <th
                                className="border-start"
                                style={{...thStyleDates, minWidth: "120px", maxWidth: "120px", width: "120px"}}>
                                {_TC("tables.containerLabel")}
                            </th>
                            <th style={{...thStyleDates, ...thStyleDates}}>{_TC("tables.island")}</th>
                            <th style={{...thStyleDates, width: "70px"}}>{_TC("tables.wasteType")}</th>
                            <th style={{...thStyleDates, textAlign: "center"}}>
                                <SortByHeader orderRef={orderRef} name={_TC("tables.average")} attr="average" />
                            </th>
                            {dateHeaders.map((d, i) => (
                                <th
                                    key={"cltdh-" + i}
                                    className="text-center border-start"
                                    style={{...thStyleDates, textAlign: "center"}}>
                                    <SortByHeader orderRef={orderRef} name={d.label} attr={"d:" + d.date} />
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody id="data-list">
                        {processedItems.map((item, index) => {
                            // Si el item tiene un groupColor, lo usamos Y ADEMÁS anulamos el boxShadow de Bootstrap.
                            const rowGroupStyle = item.groupColor
                                ? {
                                      backgroundColor: item.groupColor,
                                      boxShadow: "none", // ¡La clave está aquí!
                                  }
                                : {};

                            return (
                                <tr key={"clttr-" + index}>
                                    <td
                                        className="border-start"
                                        style={{
                                            padding: "0.4rem 0.2rem",
                                            lineHeight: "1.5",
                                            ...rowGroupStyle,
                                        }}>
                                        <Link to={"/data-view/data-container/" + item.uid + "/"} className="slx-link">
                                            {item.uid}
                                        </Link>
                                    </td>
                                    <td style={{...tdStyleIsland, height: "23px", ...rowGroupStyle}}>
                                        <div className="text-truncate">{item.island_name}</div>
                                    </td>
                                    <td
                                        style={{
                                            borderRight: "1px solid #7e7e7e",
                                            padding: "0.4rem 0.2rem",
                                            lineHeight: "1.5",
                                            ...rowGroupStyle,
                                        }}>
                                        {_Tc("wastes." + item.waste_type)}
                                    </td>
                                    <td
                                        className="text-center data-unloads"
                                        style={{
                                            ...tdStyleData,
                                            borderRight: "1px solid rgb(126, 126, 126)",
                                            backgroundColor: getLevelColor(item?.media_contenedor),
                                        }}>
                                        {item.media_contenedor != null ? Number(item.media_contenedor).toFixed(0) + "%" : "-"}
                                    </td>
                                    {dateHeaders.map((d, i) => {
                                        const hasData = item.daily_levels && d.date in item.daily_levels;
                                        const entry = hasData ? item.daily_levels[d.date] : null;
                                        const bgColor = hasData ? getLevelColor(entry.value) : "transparent";
                                        return (
                                            <td
                                                key={"clttd-" + i}
                                                className="text-center border-start data-unloads"
                                                style={{...tdStyleData, backgroundColor: bgColor}}>
                                                {hasData ? entry.value + "%" : "-"}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default ContainersListTable;
